import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M2 21L23 12L2 3V10L17 12L2 14V21Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Campaigns"
);
